import React from 'react';
import * as Yup from 'yup';

import styled from '@emotion/styled';

import CustomSelectField from '../FormCom/CustomSelectField';
import { FormComponent } from '../FormCom/FormComponent';

export const GeneralFilterSchema = Yup.object().shape({});

type SelectorDropDownFilter = {
  selector: string;
};

interface SelectorDropDownProps {
  activeField: string;
  setActiveField: (value: string) => void;
  options: string[];
}

const SelectorDropDown: React.FC<SelectorDropDownProps> = ({
  activeField,
  setActiveField,
  options,
}) => {
  const handleOnSubmit = () => {};

  const handleFieldChange = (fieldName: keyof SelectorDropDownFilter) => {
    return (value: string) => {
      if (fieldName === 'selector') {
        setActiveField(value);
      }
    };
  };

  return (
    <Container>
      <WrapFormComponent
        initialValues={{ selector: activeField }}
        schema={GeneralFilterSchema}
        onSubmit={handleOnSubmit}
      >
        <CustomSelectField
          name='selector'
          id='selector'
          placeholder={activeField || 'Select Option'}
          onChange={handleFieldChange('selector')}
          optionData={options}
        />
      </WrapFormComponent>
    </Container>
  );
};

export default SelectorDropDown;

const Container = styled.div``;

const WrapFormComponent = styled(FormComponent)`
  display: grid;
  grid-template-columns: 207px;
  gap: 8px;
`;
